import React from 'react';

import { ListView } from '@commons/utils/styledLibraryComponents';

import { ListViewContainer } from './styledComponents';

import { getColumns } from './getColumns';

const SimpleModifierCashierProductsList = ({ simpleModifierCashierProducts, isProductChild }) => {
  const columns = getColumns(isProductChild);

  return (
    <ListViewContainer>
      <ListView
        columns={columns}
        data={simpleModifierCashierProducts}
        defaultOrderBy={'name'}
        defaultOrderType={'asc'}
        isLoading={false}
        disableFooter
        disableSelection
      />
    </ListViewContainer>
  );
};

export default SimpleModifierCashierProductsList;
